import React, { Component } from "react";

import _ from "lodash";
import { toastService } from "../../services/toastService";
import Loader from "../../components/Loader";
import { LoadingDots } from "../../components/ui";
import { merchantPaymentMethodApiService } from "../../services/api/merchants/MerchantPaymentMethodApiService";
import {
    CreateCardPaymentMethodRequest,
    CreateIbanPaymentMethodRequest,
    CreateNonIbanPaymentMethodRequest,
    MerchantPaymentMethod,
} from "../../models/MerchantModel";
import { PaymentMethods } from "../../models/FinancialData";
import { AddMerchantPaymentMethod } from "./AddMerchantPaymentMethod";
import { PaymentMethodCrudComponent } from "../Banking/PaymentMethodCrudComponent";

interface MerchantPaymentMethodsState {
    isLoading: boolean;
    paymentMethods: PaymentMethods[];
    isAddPaymentMethodVisible: boolean;
    selectedPaymentMethodType: "Bank" | "NonIBAN";
}

interface MerchantPaymentMethodsProps {
    merchantId: number;
    viewOnly: boolean;
}

export default class MerchantPaymentMethodsComponent extends Component<MerchantPaymentMethodsProps, MerchantPaymentMethodsState> {
    constructor(props: MerchantPaymentMethodsProps | Readonly<MerchantPaymentMethodsProps>) {
        super(props);

        this.state = {
            isLoading: true,
            isAddPaymentMethodVisible: false,
            selectedPaymentMethodType: "Bank",
            paymentMethods: [],
        };
    }

    async componentDidMount() {
        await this.loadMethods();
    }

    loadMethods = async () => {
        this.setState({ isLoading: true });

        const paymentMethodsResult = await merchantPaymentMethodApiService.getAll(this.props.merchantId);

        if (!paymentMethodsResult.success) {
            this.setState({ isLoading: false });
            if (!paymentMethodsResult.message.includes("Merchant has missing data"))
                toastService.error(paymentMethodsResult.message);
            return;
        }

        this.setState({ paymentMethods: paymentMethodsResult.data, isLoading: false });
    };

    addPaymentMethod = (type: "Bank" | "NonIBAN") => {
        this.setState({ isAddPaymentMethodVisible: true, selectedPaymentMethodType: type });
    };

    deletePaymentMethod = async (rowData: MerchantPaymentMethod | PaymentMethods) => {
        const deleteResult = await merchantPaymentMethodApiService.delete(this.props.merchantId, rowData.value);

        if (deleteResult.success) {
            this.setState({ paymentMethods: this.state.paymentMethods.filter((a) => a.value !== rowData.value) });
        } else {
            toastService.error(deleteResult.message);
        }
    };

    updatePaymentMethod = async (rowData: CreateCardPaymentMethodRequest | CreateIbanPaymentMethodRequest | CreateNonIbanPaymentMethodRequest) => {
        const updateResult = await merchantPaymentMethodApiService.update(this.props.merchantId, rowData);

        if (updateResult.success) {
            toastService.success(updateResult.message ?? "Payment method updated.", "Action Completed");
        } else {
            toastService.error(updateResult.message ?? "Operation not allowed.");
        }
        this.loadMethods();
    };

    onHide = (): void => {
        this.setState({ isAddPaymentMethodVisible: false });
        this.loadMethods();
    };

    render() {
        if (this.state.isLoading) {
            return (
                <LoadingDots />
            );
        }
        return (
            <div>
                {this.state.isAddPaymentMethodVisible && (
                    <AddMerchantPaymentMethod merchantId={this.props.merchantId} onHide={() => this.onHide()} paymentMethodType={this.state.selectedPaymentMethodType} />
                )}
                <PaymentMethodCrudComponent
                    deletePaymentMethod={this.deletePaymentMethod}
                    updatePaymentMethod={this.updatePaymentMethod}
                    addPaymentMethod={this.addPaymentMethod}
                    paymentMethods={this.state.paymentMethods}
                />
            </div>
        );
    }
}
